module.exports = __webpack_public_path__ + "img/GNLoyalty.b9426be5.png";